import { IObservable, Observable } from "thrive-observable-react";

//interfaces
import { IContentTile } from "thrive-components";
import { SignUpStepRoutes, SignUpSteps } from "../../interfaces/Navigation";

//services
import { SUACService } from "../../services/SignUpAppConfig.service";
import { navigateTo } from "../../services/navigation.service";

//api
import { createApp } from "../../api/selfSignUp";


class DesignModel {
    public title: string = 'Customise your demo app';
    public subtitle: string = 'Pick a colour and rearrange tiles to make it yours.';
    public reorderButton: string = "Reorder tiles";
    public button: string = "Save & continue";
    public showReorderContentTilesModal : IObservable<boolean> = Observable(false);
    public loading : IObservable<boolean> = Observable(false);
    public showErrorBanner : IObservable<boolean> = Observable(false);

    public onReorderTilesClick = () => {
        this.showReorderContentTilesModal.update(true);
    }

    public hideReorderContentTilesModal = () => {
        this.showReorderContentTilesModal.update(false);
    }

    public onSaveContentOrderClick = (content: IContentTile[]) => {
        SUACService.updateContentTiles(content);
        this.showReorderContentTilesModal.update(false);
    }

    private showTemporaryError = () => {
        this.showErrorBanner.update(true);

        setTimeout(() => {
            this.showErrorBanner.update(false);
        }, 6000);
    }

    public onContinueClick = async () => {
        const form = SUACService.createAppForm.value;
        if (!form) return;
        
        this.loading.update(true);
        const res = await createApp(form)
            .catch(() => {
                this.showTemporaryError();
                this.loading.update(false);
            });
                    
            if(res?.data) {
                this.loading.update(false);
                SUACService.updateCmsUrl(res.data.loginUrl);
                SUACService.setOrgShortName(res.data.orgShortName);

                //navigate to next step
                SUACService.setCurrentStep(SignUpSteps.DOWNLOAD);
                navigateTo(SignUpStepRoutes[SignUpSteps.DOWNLOAD]);
            }
    }
}


export { DesignModel };